import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import ModalComponent from '../../ui/Modal';

import { popError } from '../../global/actions';

const mapStateToProps = state => ({
  user: state.Dashboard.user,
  errors: state.Global.errors
});

class BookingCancellationComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillUnmount() {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'bookingerror').length > 0) {
      this.props.dispatch(popError('bookingerror'));
    }
  }

  componentDidUpdate() {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'bookingerror').length > 0) {
      this.setState({ isSubmitting: false });
    }
  }

  onSubmit() {
    setTimeout(() => this.setState({ isSubmitting: true }), 240);
    this.props.onSubmit();
  }

  renderBody(card, total, error) {
    return (<div>
      <div className="font-weight-bold">Are you sure you want to cancel?</div>
      <div className="col-12">
        <strong>Note:</strong> Cancellation refund amounts are subject to the policies outlined in the <a href="/terms-conditions" target="_blank">Terms & Conditions</a>.
      </div>
      {error && (<div className="error-message">{error.message}</div>)}
    </div>)
  }

  renderButtonRow(card, error, onClose, isSubmitting) {
    let button = (<div />);
    if (error) { button = (<button className='btn btn-primary' disabled={true} >Error</button>) }
    else if (isSubmitting) { button = (<button className='btn btn-primary' disabled={true} >Processing...</button>) }
    else if (card) { button = (<button className='btn btn-primary' onClick={this.onSubmit} >Continue</button>) }
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col pl-0">
          <label onClick={onClose}>Back</label>
        </div>
        <div className="col text-right">
          {button}
        </div>
      </div>
    )
  }

  render() {
    let { user, total, errors, onClose } = this.props;
    let { isSubmitting } = this.state;
    let card = null;
    if ( Array.isArray(user.creditCards) && user.creditCards.length ) {
      card = user.creditCards[0];
    }
    let error = errors
      ? errors.filter(e => e.errType === 'bookingerror')[0]
      : null;
    return (
      <ModalComponent
        id="CancellationModal" title="Cancel Booking"
        body={ this.renderBody(card, total, error, isSubmitting) }
        footer={ this.renderButtonRow(card, error, onClose, isSubmitting) }
        onClose={onClose} />
    );

  }
}

export default connect(mapStateToProps)(BookingCancellationComponent);
